import PlayerRegistrationStep from './step';

export default class PlayerRegistrationStep3 extends PlayerRegistrationStep {
    constructor(...args) {
        super(...args);

        this.isScrolledDown = false;
        this.onTermsScroll = this.onTermsScroll.bind(this);
    }

    static getRequiredRefs() {
        return ['terms', 'continue'];
    }

    initConcrete() {
        this.handleDisableButton(false);
        this.addListenersConcrete();
    }

    addListenersConcrete() {
        this.refs.terms.addEventListener('scroll', this.onTermsScroll);
    }

    applyStateConcrete() {
    }

    isStepValid() {
        return this.isScrolledDown;
    }

    onTermsScroll() {
        this.checkIsScrolledDown();
    }

    checkIsScrolledDown() {
        if (this.isScrolledDown !== true) {
            const termsElement = this.refs.terms;
            const scrollHeight = (termsElement.scrollHeight-1000);
            const isScrolledDown = (termsElement.scrollTop + termsElement.clientHeight) >= scrollHeight;
            if (isScrolledDown !== this.isScrolledDown) {
                this.applyIsScrolledDown(isScrolledDown);
            }
        }
    }

    applyIsScrolledDown(isScrolledDown) {
        this.isScrolledDown = isScrolledDown;
        if (this.isScrolledDown) {
            this.refs.terms.removeEventListener('scroll', this.onTermsScroll);
            this.handleDisableButton(true);
        }
    }

    handleDisableButton(isValid) {
        if (this.refs.continue) {
            if (isValid) {
                this.refs.continue.removeAttribute('disabled');
            } else {
                this.refs.continue.setAttribute('disabled', 'disabled');
            }
        }
        if (isValid) {
            this.refs.terms.classList.add('is-scrolled');
        }
    }
}
